import { jsx as T } from "react/jsx-runtime";
import { createContext as f, useState as c, useEffect as p, useMemo as w, useContext as x } from "react";
const g = {
  theme: "system",
  computedTheme: "light",
  setTheme: () => null
}, h = f(g);
function C({
  children: s,
  defaultTheme: i = "system",
  storageKey: o = "ui-theme",
  ...u
}) {
  const [e, d] = c(() => localStorage.getItem(o) || i), [m, n] = c(a());
  p(() => {
    const t = window.document.documentElement;
    if (t.classList.remove("light", "dark"), e === "system") {
      const r = a();
      n(r), t.classList.add(r);
      return;
    } else
      n(e);
    t.classList.add(e);
  }, [e]);
  const l = w(
    () => ({
      theme: e,
      computedTheme: m,
      setTheme: (t) => {
        localStorage.setItem(o, t), d(t);
      }
    }),
    [m, o, e]
  );
  return /* @__PURE__ */ T(h.Provider, { ...u, value: l, children: s });
}
function a() {
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
const k = () => {
  const s = x(h);
  if (s === void 0) throw new Error("useTheme must be used within a Themed");
  return s;
};
export {
  C as T,
  h as a,
  k as u
};
//# sourceMappingURL=use-theme-xHxAHy0N.js.map
